import React from "react";
// UI Frameworks
import { toast } from "react-toastify";
// Common Components
import { Button } from "src/Components";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import FileDownloader from "src/Components/FileDownloader";
import FileInput from "src/Components/FileInput/FileInput";
// Services
import {
  getPairConfigTable,
  getPairConfigExcel,
  uploadPairConfigExcel,
} from "src/Requests/goldArbitrage";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import {
  PairConfigSearchParams,
  PairConfigTableReport,
} from "src/Interfaces/goldArbitrage";

const PairConfig = () => {
  const [loading, setLoading] = React.useState(false);
  const [file, setFile] = React.useState<FormData | null>(null);

  const uploadFileHandler = () => {
    if (!file) return;
    setLoading(true);
    uploadPairConfigExcel(file)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setFile(null);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="min-h-32 min-w-[300px] w-full max-w-full overflow-x-auto ">
      <TableTemplate<PairConfigSearchParams, PairConfigTableReport>
        TableUI={({ reports, onAction }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            tableBoxClassName="max-h-[500px]"
          />
        )}
        getDataTable={getPairConfigTable}
        searchParameters={{} as PairConfigSearchParams}
      />
      <div className="flex gap-3 justify-start w-96">
        <FileDownloader getFile={getPairConfigExcel} />

        <FileInput
          name="file"
          UI={<></>}
          label="آپلود اکسل"
          value={file}
          onChange={setFile}
        />

        <div className="w-20">
          <Button
            variant="contained"
            text="ارسال اکسل"
            onClick={uploadFileHandler}
            disabled={!file}
          />
        </div>
      </div>
    </div>
  );
};

export default PairConfig;
